import React from 'react'
import clsx from 'clsx'

import { ReactComponent as StarSVG } from 'resources/graphics/journey_page_points_star.svg'
import { ReactComponent as CheckmarkSVG } from 'resources/graphics/checkmark_simple.svg'
import { ReactComponent as LockSVG } from 'resources/graphics/lock.svg'
import { ReactComponent as GiftSVG } from 'resources/graphics/gift.svg'

import styles from './Label.module.scss'

type IconProps = { large?: boolean }

export { styles }

export const StarIcon = ({ large }: IconProps) => (
  <StarSVG className={clsx(styles.icon, styles.star, large && styles.large)} aria-hidden="true" focusable="false" />
)

export const DoneIcon = ({ large }: IconProps) => (
  <CheckmarkSVG className={clsx(styles.icon, large && styles.large)} aria-hidden="true" focusable="false" />
)

export const LockIcon = ({ large }: IconProps) => (
  <LockSVG className={clsx(styles.icon, large && styles.large)} aria-hidden="true" focusable="false" />
)

export const GiftIcon = ({ large }: IconProps) => (
  <GiftSVG className={clsx(styles.icon, large && styles.large)} aria-hidden="true" focusable="false" />
)
